import { useState } from 'react';

import './Header.css';
import HamSubMenuPublic from './hamburgerSubmenu/HamSubMenuPublic';

export default function HamburgerMenuPublic() {
  const [hamSubMenuOpen, handleHamSubMenu] = useState(
    'ham-sub-menu ham-sub-menu-toggle'
  );
  const [hamToggle, handleHamToggle] = useState('ham');

  const hamSubMenuToggle = () => {
    hamSubMenuOpen === 'ham-sub-menu'
      ? handleHamSubMenu('ham-sub-menu ham-sub-menu-toggle')
      : handleHamSubMenu('ham-sub-menu');
    hamToggle === 'ham'
      ? handleHamToggle('ham toggle')
      : handleHamToggle('ham');
  };

  return (
    <>
      <div className='hamburger-icon-wrap' onClick={hamSubMenuToggle}>
        <div className={hamToggle}>
          <div className='line-1'></div>
          <div className='line-2'></div>
          <div className='line-3'></div>
        </div>
      </div>
      <HamSubMenuPublic
        hamSubMenuOpen={hamSubMenuOpen}
        closeMenu={hamSubMenuToggle}
      />
    </>
  );
}
